<template>
    <div>
        <div class="callout callout-danger" style="display:none" id="screenPermission">
            <h5 class="bg-gradient-danger">Sorry!</h5>
            <div id="message"></div>
        </div>
        <div class="card card-primary card-outline card-outline-tabs" id="mainform">
            <div class="card-body">
            <div class="card-header p-0 border-bottom-0">
                <ul class="nav nav-tabs" id="tabhead">
                    <li class="nav-item basic-tabs" @click="shownexttab('basic-tabs')">
                        <a class="nav-link active" id="basic-tabs-head" data-toggle="pill"  href="#basic-tabs" role="tab" aria-controls="custom-tabs-four-home" aria-selected="true">
                            <label> Basic Details</label>
                        </a>
                    </li>
                    <li class="nav-item guardians-tab"  @click="shownexttab('guardians-tab')">
                        <a class="nav-link" id="guardians-tab-head" data-toggle="pill" href="#guardians-tab" role="tab" aria-controls="custom-tabs-four-guardians" aria-selected="false">
                            <label>Student Guardian and Parents Details</label>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="card-body">
                <div class="tab-content">
                    <div class="tab-pane fade active show tab-content-details" id="basic-tabs" role="tabpanel" aria-labelledby="basicdetails">
                        <form id="admission_form" class="form-horizontal" enctype="multipart/form-data" action="#" method="POST">
                            <div class="row form-group">
                                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                                    <label> Student Nationality:<span class="text-danger">*</span></label><br>
                                    <input type="radio" disabled name="snationality" v-model="personal_form.snationality" value="Bhutanese" id="s-bhutanese" @click="showstdidentity('Student-Bhutanese')" checked> Bhutanese <br>
                                    <input type="radio" disabled name="snationality" v-model="personal_form.snationality" value="Bhutanese Under Process" id="s-bhutanese-underprocess" @click="showstdidentity('Student-Bhutanese-underprocess')" checked> CID Under Process<br>
                                    <input type="radio" disabled name="snationality" v-model="personal_form.snationality" value="Foreign" id="s-foreign" @click="showstdidentity('Student-Non-Bhutanese')"> Non-Bhutanese
                                    <span class="text-danger" id="snationality_err"></span>
                                </div>
                                <div class="row form-group col-lg-9 col-md-9 col-sm-9">
                                    <div class="card card-primary">
                                        <div class="card-body">
                                            <div class="row form-group">
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <label id="level_name"></label>
                                                    <input type="text" class="form-control"  @change="remove_error('cid_passport')" :class="{ 'is-invalid': personal_form.errors.has('cid_passport') }" id="cid_passport" v-model="personal_form.cid_passport" placeholder="Identification No">
                                                    <has-error :form="personal_form" field="cid_passport"></has-error>
                                                </div>
                                            </div>
                                            <div class="row form-group">
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <label >First Name:<span class="text-danger">*</span> </label>
                                                    <input type="text" class="form-control" @change="remove_error('first_name')" :class="{ 'is-invalid': personal_form.errors.has('first_name') }" id="first_name" v-model="personal_form.first_name" placeholder="First Name">
                                                    <has-error :form="personal_form" field="first_name"></has-error>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <label > Middle Name: </label>
                                                    <input type="text" class="form-control" @change="remove_error('middle_name')" :class="{ 'is-invalid': personal_form.errors.has('middle_name') }" id="middle_name" v-model="personal_form.middle_name" placeholder="Middle Name">
                                                    <has-error :form="personal_form" field="middle_name"></has-error>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <label >Last Name: </label>
                                                    <input type="text" class="form-control" @change="remove_error('last_name')" :class="{ 'is-invalid': personal_form.errors.has('last_name') }" id="last_name" v-model="personal_form.last_name" placeholder="Last Name">
                                                    <has-error :form="personal_form" field="last_name"></has-error>
                                                </div>
                                            </div>
                                            <div class="row form-group">
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <label>Date of Birth:<span class="text-danger">*</span></label>
                                                    <input type="date" class="form-control" @change="remove_error('dob')" :class="{ 'is-invalid': personal_form.errors.has('dob') }" id="dob" v-model="personal_form.dob" placeholder="Date of Birth">
                                                    <has-error :form="personal_form" field="dob"></has-error>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                    <label>Gender:<span class="text-danger">*</span></label>
                                                    <select v-model="personal_form.sex_id" :class="{ 'is-invalid select2 select2-hidden-accessible': personal_form.errors.has('sex_id') }" class="form-control select2" name="sex_id" id="sex_id">
                                                        <option value=""> --Select--</option>
                                                        <option v-for="(item, index) in sex_idList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                                    </select>
                                                    <has-error :form="personal_form" field="sex_id"></has-error>
                                                </div>
                                            </div>
                                            <div class="row form-group" id="dzo_gewog_village">
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <label>Dzongkhag/Thromde:<span class="text-danger">*</span> </label>
                                                    <select v-model="personal_form.dzongkhag" :class="{ 'is-invalid select2 select2-hidden-accessible': personal_form.errors.has('dzongkhag') }" class="form-control select2" name="dzongkhag" id="dzongkhag">
                                                        <option value=""> --Select--</option>
                                                        <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                                    </select>
                                                    <has-error :form="personal_form" field="dzongkhag"></has-error>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <label> Gewog:<span class="text-danger">*</span></label>
                                                    <select v-model="personal_form.gewog" :class="{ 'is-invalid select2 select2-hidden-accessible': personal_form.errors.has('gewog') }" class="form-control select2" name="gewog" id="gewog">
                                                        <option value=""> --Select--</option>
                                                        <option v-for="(item, index) in std_gewog_list" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                                    </select>
                                                    <has-error :form="personal_form" field="gewog"></has-error>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                                    <label>Village:<span class="text-danger">*</span></label>
                                                    <select v-model="personal_form.village_id" :class="{ 'is-invalid select2 select2-hidden-accessible': personal_form.errors.has('village_id') }" class="form-control select2" name="village_id" id="village_id">
                                                        <option value=""> --Select--</option>
                                                        <option v-for="(item, index) in std_villageList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                                    </select>
                                                    <has-error :form="personal_form" field="village_id"></has-error>
                                                </div>
                                            </div>
                                            <div class="row form-group" id="std_permanent_address">
                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                    <label >Permanent Address: </label>
                                                    <textarea class="form-control" rows="3" @change="remove_error('fulladdress')" :class="{ 'is-invalid': personal_form.errors.has('fulladdress') }" id="fulladdress" v-model="personal_form.fulladdress" placeholder="Permanent Address"></textarea>
                                                    <has-error :form="personal_form" field="fulladdress"></has-error>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label>Supporting Document</label>
                                    <input type="file" name="attachments" class="form-control" v-on:change="onChangeFileUpload" id="attachment">
                                    <has-error :form="personal_form" field="attachments"></has-error>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label>Class:  <span class="text-danger">*</span></label>
                                    <select v-model="personal_form.std_class" :class="{ 'is-invalid select2 select2-hidden-accessible': personal_form.errors.has('std_class') }" class="form-control select2" name="std_class" id="std_class">
                                        <option value=""> --Select--</option>
                                        <option v-for="(item, index) in s_classList" :key="index" v-bind:value="item.class">{{ item.class }}</option>
                                    </select>
                                    <has-error :form="personal_form" field="std_class"></has-error>
                                </div>
                            </div>
                            <!-- loading attachment -->
                            <div class="form-group row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table id="participant-table" class="table w-100 table-bordered table-striped">
                                        <thead>
                                            <tr>
                                                <th>Uploaded Document</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td v-if="filepth">
                                                    <a href="#" @click="openfile(filepth)" class="fa fa-download"> Download</a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <hr>
                            <div class="row form-group fa-pull-right" id="next_btn">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <button class="btn btn-flat btn-primary" type="button" @click="shownexttab('guardians-tab')"> Next <i class="fa fa-arrow-right"></i></button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="tab-pane fade tab-content-details" id="guardians-tab" role="tabpanel" aria-labelledby="basicdetails">
                        <div class="row form-group">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label>Parent's Marital Status:<span class="text-danger">*</span></label>
                                <select v-model="guardian_form.merital_status" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('merital_status') }" class="form-control select2" name="merital_status" id="merital_status">
                                    <option value=""> --Select--</option>
                                    <option v-for="(item, index) in marital_statusList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                </select>
                                <has-error :form="guardian_form" field="merital_status"></has-error>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label> Student Primary Contact:</label><br>
                                <label id="primary_contact_Father"><input type="radio" value="Father" v-model="guardian_form.primary_contact" :class="{ 'is-invalid': guardian_form.errors.has('primary_contact') }" name="primary_contact" @change="remove_error('primary_contact')" @click="showidentity('Father')" > Father</label>
                                <label id="primary_contact_Mother"><input type="radio" value="Mother" v-model="guardian_form.primary_contact" :class="{ 'is-invalid': guardian_form.errors.has('primary_contact') }" name="primary_contact" @change="remove_error('primary_contact')" @click="showidentity('Mother')" > Mother</label>
                                <label id="primary_contact_Guardian"><input type="radio" value="guardian" v-model="guardian_form.primary_contact" :class="{ 'is-invalid': guardian_form.errors.has('primary_contact') }" name="primary_contact" @change="remove_error('primary_contact')" @click="showidentity('primary-contact-guardian')"> Guardian</label>
                                <has-error :form="guardian_form" field="primary_contact"></has-error>
                                <br /><span class="text-danger" id="primary_contact_error"></span>
                            </div>
                        </div>
                        <hr>
                        <div class="row form-group" style="display:none" id="father_details">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <dt><u>Father's Details</u></dt>
                                <div class="row form-group">
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <label>  Nationality:</label><br>
                                        <input type="radio" v-model="guardian_form.father_nationality" value="Bhutanese" @click="showfathersidentity('bhutanese')" name="father_nationality" id="father_nationality" checked> Bhutanese
                                        <input type="radio" v-model="guardian_form.father_nationality" value="Foreign" @click="showfathersidentity('foreign')" name="father_nationality" id="father_nationality1"> Non-Bhutanese
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                        <label>Father's CID, Immigration ID/Other Document ID:<span class="text-danger">*</span> </label>
                                        <input type="text" v-model="guardian_form.father_cid_passport" class="form-control" @change="remove_error('father_cid_passport')" :class="{ 'is-invalid': guardian_form.errors.has('father_cid_passport') }" id="father_cid_passport" placeholder="Identification No">
                                        <has-error :form="guardian_form" field="father_cid_passport"></has-error>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 pt-4 mt-1" id="fetch_father_details">
                                        <!-- <button type="button" id="father_cid_fetch" @click="getDetailsbyCID('father_cid_passport','father')" class="btn btn-primary"> <i class="fa fa-download"></i> Fetch</button> -->
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                        <label >Name:<span class="text-danger">*</span> </label>
                                        <input type="text" v-model="guardian_form.father_first_name" class="form-control" @change="remove_error('father_first_name')" :class="{ 'is-invalid': guardian_form.errors.has('father_first_name') }" id="father_first_name" placeholder="Name">
                                        <has-error :form="guardian_form" field="father_first_name"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group" id="father_dzo_gewog_village">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Dzongkhag/Thromde:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.father_dzongkhag" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('father_dzongkhag') }" class="form-control select2" name="father_dzongkhag" id="father_dzongkhag">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="father_dzongkhag"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label> Gewog:<span class="text-danger">*</span></label>
                                        <select v-model="guardian_form.father_gewog" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('father_gewog') }" class="form-control select2" name="father_gewog" id="father_gewog">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in p_father_gewog_list" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="father_gewog"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Village:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.father_village_id" :class="{ 'is-invalid select2-hidden-accessible': guardian_form.errors.has('father_village_id') }" class="form-control" name="father_village_id" id="father_village_id1">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in p_father_villageList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="father_village_id1"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group" id="father_permanent_address" style="display:none">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label >Permanent Address: </label>
                                        <textarea class="form-control" @change="remove_error('father_fulladdress')" :class="{ 'is-invalid': guardian_form.errors.has('father_fulladdress') }" id="father_fulladdress" v-model="guardian_form.father_fulladdress" placeholder="Permanent Address"></textarea>
                                        <has-error :form="guardian_form" field="father_fulladdress"></has-error>
                                    </div>
                                </div>
                                <label><u> Present Address</u></label>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Dzongkhag/Thromde:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.father_present_dzongkhag" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('father_present_dzongkhag') }" class="form-control select2" name="father_present_dzongkhag" id="father_present_dzongkhag">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="father_present_dzongkhag"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label> Gewog:<span class="text-danger">*</span></label>
                                        <select v-model="guardian_form.father_present_gewog" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('father_present_gewog') }" class="form-control select2" name="father_present_gewog" id="father_present_gewog">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in father_gewog_list" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="father_present_gewog"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Village:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.father_present_village_id" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('father_present_village_id') }" class="form-control select2" name="father_present_village_id" id="father_present_village_id">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in father_villageList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="father_present_village_id"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label>Work Address:<span class="text-danger">*</span> </label>
                                        <textarea class="form-control" @change="remove_error('father_work_address')" :class="{ 'is-invalid': guardian_form.errors.has('father_work_address') }" id="father_work_address" v-model="guardian_form.father_work_address" placeholder="Working Address"></textarea>
                                        <has-error :form="guardian_form" field="father_work_address"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label>Residence Address:<span class="text-danger">*</span> </label>
                                        <textarea class="form-control" @change="remove_error('father_residence_address')" :class="{ 'is-invalid': guardian_form.errors.has('father_residence_address') }" id="father_residence_address" v-model="guardian_form.father_residence_address" placeholder="Residence Address"></textarea>
                                        <has-error :form="guardian_form" field="father_residence_address"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Occupation: <span class="text-danger">*</span></label>
                                        <select v-model="guardian_form.father_occupation" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('father_occupation') }" class="form-control select2" name="father_occupation" id="father_occupation">
                                            <option value=""> --Select--</option>
                                            <!-- <option value="Civil Servant"> Civil Servant</option>
                                            <option value="Private Employee"> Private Employee</option>
                                            <option value="Business"> Business</option>
                                            <option value="Farmer"> Farmer</option>
                                            <option value="Unemployed"> Unemployed</option> -->
                                            <option v-for="(item, index) in occupationList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="father_occupation"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Email Address:</label>
                                        <input type="text" class="form-control" @change="remove_error('father_email');validateEmail('email','emailError')" :class="{ 'is-invalid': guardian_form.errors.has('father_email') }" id="father_email" v-model="guardian_form.father_email" placeholder="Email Address">
                                        <has-error :form="guardian_form" field="father_email"></has-error>
                                        <span class="text-danger" id="emailError"></span>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Contact No: <span class="text-danger">*</span></label>
                                        <input type="number" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "8" minlength = "8" class="form-control" @change="remove_error('father_conact_no')" :class="{ 'is-invalid': guardian_form.errors.has('father_cntct_no') }" id="father_conact_no" v-model="guardian_form.father_cntct_no" placeholder="Contact No">
                                        <has-error :form="guardian_form" field="father_cntct_no"></has-error>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form-group" style="display:none" id="mother_details">
                            <hr>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <dt><u>Mother's Details</u></dt>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>  Nationality:<span class="text-danger">*</span></label><br>
                                        <input type="radio" value="Bhutanese" v-model="guardian_form.mother_nationality" @click="showmothersidentity('bhutanese')" name="mother_nationality" id="mother_nationality" checked> Bhutanese
                                        <input type="radio" value="Foreign" v-model="guardian_form.mother_nationality" @click="showmothersidentity('foreign')" name="mother_nationality" id="mother_nationality1"> Non-Bhutanese
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                        <label>Mother's CID, Immigration ID/Other Document:<span class="text-danger">*</span> </label>
                                        <input type="text" v-model="guardian_form.mother_cid_passport" class="form-control" @change="remove_error('mother_cid_passport')" :class="{ 'is-invalid': guardian_form.errors.has('mother_cid_passport') }" id="mother_cid_passport" placeholder="Identification No">
                                        <has-error :form="guardian_form" field="mother_cid_passport"></has-error>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 pt-4 mt-1" id="fetch_mother_details">
                                        <!-- <button type="button"  @click="getDetailsbyCID('mother_cid_passport','mother')" class="btn btn-primary"> <i class="fa fa-download"></i> Fetch</button> -->
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                        <label >Name:<span class="text-danger">*</span> </label>
                                        <input type="text" class="form-control" @change="remove_error('mother_first_name')" :class="{ 'is-invalid': guardian_form.errors.has('mother_first_name') }" id="mother_first_name" v-model="guardian_form.mother_first_name" placeholder="Name">
                                        <has-error :form="guardian_form" field="mother_first_name"></has-error>
                                    </div>
                                </div>

                                <div class="row form-group" id="mothers_dzo_gewog_village">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Dzongkhag/Thromde:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.mother_dzongkhag" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('mother_dzongkhag') }" class="form-control select2" name="mother_dzongkhag" id="mother_dzongkhag">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="mother_dzongkhag"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label> Gewog:<span class="text-danger">*</span></label>
                                        <select v-model="guardian_form.mother_gewog" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('mother_gewog') }" class="form-control select2" name="mother_gewog" id="mother_gewog">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in p_mother_gewog_list" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="mother_gewog"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Village:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.mother_village_id" :class="{ 'is-invalid select2-hidden-accessible': guardian_form.errors.has('mother_village_id') }" class="form-control" name="mother_village_id" id="mother_village_id">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in p_mother_villageList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="mother_village_id"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group" id="mothers_permanent_address" style="display:none">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label>Permanent Address: </label>
                                        <textarea class="form-control" @change="remove_error('mother_fulladdress')" :class="{ 'is-invalid': guardian_form.errors.has('mother_fulladdress') }" id="mother_fulladdress" v-model="guardian_form.mother_fulladdress" placeholder="Permanent Address"></textarea>
                                        <has-error :form="guardian_form" field="mother_fulladdress"></has-error>
                                    </div>
                                </div>
                                <label><u> Present Address</u></label>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Dzongkhag/Thromde:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.mother_present_dzongkhag" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('mother_present_dzongkhag') }" class="form-control select2" name="mother_present_dzongkhag" id="mother_present_dzongkhag">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="mother_present_dzongkhag"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label> Gewog:<span class="text-danger">*</span></label>
                                        <select v-model="guardian_form.mother_present_gewog" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('mother_present_gewog') }" class="form-control select2" name="mother_present_gewog" id="mother_present_gewog">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in mother_gewog_list" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="mother_present_gewog"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Village:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.mother_present_village_id" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('mother_present_village_id') }" class="form-control select2" name="mother_present_village_id" id="mother_present_village_id">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in mother_villageList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="mother_present_village_id"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label>Work Address:<span class="text-danger">*</span> </label>
                                        <textarea class="form-control" @change="remove_error('mother_work_address')" :class="{ 'is-invalid': guardian_form.errors.has('mother_work_address') }" id="mother_work_address" v-model="guardian_form.mother_work_address" placeholder="Working Address"></textarea>
                                        <has-error :form="guardian_form" field="mother_work_address"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label>Residence Address:<span class="text-danger">*</span> </label>
                                        <textarea class="form-control" @change="remove_error('mother_residence_address')" :class="{ 'is-invalid': guardian_form.errors.has('mother_residence_address') }" id="mother_residence_address" v-model="guardian_form.mother_residence_address" placeholder="Residence Address"></textarea>
                                        <has-error :form="guardian_form" field="mother_residence_address"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Occupation: </label>
                                        <select v-model="guardian_form.mother_occupation" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('mother_occupation') }" class="form-control select2" name="mother_occupation" id="mother_occupation">
                                            <option value=""> --Select--</option>
                                            <!-- <option value="Civil Servant"> Civil Servant</option>
                                            <option value="Private Employee"> Private Employee</option>
                                            <option value="Business"> Business</option>
                                            <option value="Farmer"> Farmer</option>
                                            <option value="Unemployed"> Unemployed</option> -->
                                            <option v-for="(item, index) in occupationList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="mother_occupation"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Email Address:</label>
                                        <input type="text" class="form-control" @change="remove_error('mother_email');validateEmail('email','emailError')" :class="{ 'is-invalid': guardian_form.errors.has('mother_email') }" id="mother_email" v-model="guardian_form.mother_email" placeholder="Email Address">
                                        <has-error :form="guardian_form" field="mother_email"></has-error>
                                         <span class="text-danger" id="emailError"></span>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Contact No: <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "8" minlength = "8" @change="remove_error('mother_cntct_no')" :class="{ 'is-invalid': guardian_form.errors.has('mother_cntct_no') }" id="mother_cntct_no" v-model="guardian_form.mother_cntct_no" placeholder="Contact No">
                                        <has-error :form="guardian_form" field="mother_cntct_no"></has-error>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row form-group" style="display:none" id="gardain_section">
                            <hr>
                            <div class="card-body">
                                <dt>Guardian's Details</dt>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Nationality:</label><br>
                                        <input type="radio" value="Bhutanese" v-model="guardian_form.gardain_nationality" @click="showgardainsidentity('bhutanese')" name="gardain_nationality" id="gardain_nationality" checked> Bhutanese
                                        <input type="radio" value="Foreign" v-model="guardian_form.gardain_nationality" @click="showgardainsidentity('foreign')" name="gardain_nationality" id="gardain_nationality1"> Non-Bhutanese
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                        <label>CID, Immigration ID/Other Document ID: <span class="text-danger">*</span></label>
                                        <input type="text" v-model="guardian_form.gardain_cid_passport" class="form-control"  @change="remove_error('gardain_cid_passport')" :class="{ 'is-invalid': guardian_form.errors.has('gardain_cid_passport') }" id="gardain_cid_passport" placeholder="Identification No">
                                        <has-error :form="guardian_form" field="gardain_cid_passport"></has-error>
                                    </div>
                                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 pt-4 mt-1" id="fetch_guradian_details">
                                        <button type="button" @click="getDetailsbyCID('gardain_cid_passport','gardain')" class="btn btn-primary"> <i class="fa fa-download"></i> Fetch</button>
                                    </div>
                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                         <label >Name:<span class="text-danger">*</span> </label>
                                        <input type="text" class="form-control" @change="remove_error('gardain_first_name')" :class="{ 'is-invalid': guardian_form.errors.has('gardain_first_name') }" id="gardain_first_name" v-model="guardian_form.gardain_first_name" placeholder="Name">
                                        <has-error :form="guardian_form" field="gardain_first_name"></has-error>
                                    </div>

                                </div>
                                <div class="row form-group" id="gardain_dzo_gewog_village">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Dzongkhag/Thromde:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.gardain_dzongkhag" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('gardain_dzongkhag') }" class="form-control select2" name="gardain_dzongkhag" id="gardain_dzongkhag">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="gardain_dzongkhag"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label> Gewog:<span class="text-danger">*</span></label>
                                        <select v-model="guardian_form.gardain_gewog" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('gardain_gewog') }" class="form-control select2" name="gardain_gewog" id="gardain_gewog">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in p_gardain_gewog_list" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="gardain_gewog"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Village:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.gardain_village_id" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('gardain_village_id') }" class="form-control select2" name="gardain_village_id" id="gardain_village_id">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in p_gardain_villageList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="gardain_village_id"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group" id="gardain_permanent_address" style="display:none">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label >Permanent Address: </label>
                                        <textarea class="form-control" @change="remove_error('gardain_fulladdress')" :class="{ 'is-invalid': guardian_form.errors.has('gardain_fulladdress') }" id="gardain_fulladdress" v-model="guardian_form.gardain_fulladdress" placeholder="Permanent Address"></textarea>
                                        <has-error :form="guardian_form" field="gardain_fulladdress"></has-error>
                                    </div>
                                </div>
                                <label><u> Present Address</u></label>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Dzongkhag/Thromde:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.gardain_present_dzongkhag" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('gardain_present_dzongkhag') }" class="form-control select2" name="gardain_present_dzongkhag" id="gardain_present_dzongkhag">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in dzongkhagList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="gardain_present_dzongkhag"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label> Gewog:<span class="text-danger">*</span></label>
                                        <select v-model="guardian_form.gardain_present_gewog" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('gardain_present_gewog') }" class="form-control select2" name="gardain_present_gewog" id="gardain_present_gewog">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in gardain_gewog_list" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="gardain_present_gewog"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Village: <span class="text-danger">*</span></label>
                                        <select v-model="guardian_form.gardain_present_village_id" :class="{ 'is-invalid select2-hidden-accessible': guardian_form.errors.has('gardain_present_village_id') }" class="form-control" name="gardain_present_village_id" id="gardain_present_village_id">
                                            <option value=""> --Select--</option>
                                            <option v-for="(item, index) in gardain_villageList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="gardain_present_village_id"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label>Work Address: <span class="text-danger">*</span></label>
                                        <textarea class="form-control" @change="remove_error('gardain_work_address')" :class="{ 'is-invalid': guardian_form.errors.has('gardain_work_address') }" id="gardain_work_address" v-model="guardian_form.gardain_work_address" placeholder="Working Address"></textarea>
                                        <has-error :form="guardian_form" field="gardain_work_address"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label>Residence Address:<span class="text-danger">*</span> </label>
                                        <textarea class="form-control" @change="remove_error('gardain_residence_address')" :class="{ 'is-invalid': guardian_form.errors.has('gardain_residence_address') }" id="gardain_residence_address" v-model="guardian_form.gardain_residence_address" placeholder="Residence Address"></textarea>
                                        <has-error :form="guardian_form" field="gardain_residence_address"></has-error>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Occupation:<span class="text-danger">*</span> </label>
                                        <select v-model="guardian_form.gardain_occupation" :class="{ 'is-invalid select2 select2-hidden-accessible': guardian_form.errors.has('gardain_occupation') }" class="form-control select2" name="occupation" id="gardain_occupation">
                                            <option value=""> --Select--</option>
                                            <!-- <option value="Civil Servant"> Civil Servant</option>
                                            <option value="Private Employee"> Private Employee</option>
                                            <option value="Business"> Business</option>
                                            <option value="Farmer"> Farmer</option>
                                            <option value="Unemployed"> Unemployed</option> -->
                                            <option v-for="(item, index) in occupationList" :key="index" v-bind:value="item.id">{{ item.name }}</option>
                                        </select>
                                        <has-error :form="guardian_form" field="gardain_occupation"></has-error>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Email Address:</label>
                                        <input type="text" class="form-control" @change="remove_error('gardain_email');validateEmail('email','emailError')" :class="{ 'is-invalid': guardian_form.errors.has('gardain_email') }" id="gardain_email" v-model="guardian_form.gardain_email" placeholder="Email Address">
                                        <has-error :form="guardian_form" field="gardain_email"></has-error>
                                        <span class="text-danger" id="emailError"></span>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label>Contact No:<span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength = "8" minlength = "8" @change="remove_error('gardain_cntct_no')" :class="{ 'is-invalid': guardian_form.errors.has('gardain_cntct_no') }" id="gardain_cntct_no" v-model="guardian_form.gardain_cntct_no" placeholder="Contact No">
                                        <has-error :form="guardian_form" field="gardain_cntct_no"></has-error>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row form-group fa-pull-right">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <button class="btn btn-flat btn-success"  @click="shownexttab('basic-tabs')"><i class="fa fa-arrow-left"></i> Previous </button>
                                <button id="subbtn" class="btn btn-flat btn-primary" @click="submitfinalform('details-tab')"> Submit <i class="fa fa-arrow-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            filepth:[],
            org_type:'',
            marital_statusList:[],
            schoolAdmissionDateValidation:'',
            eccdAdmissionDateValidation:'',
            loop_check:true,
            sex_idList:[],
            dzongkhagList:[],
            std_gewog_list:[],
            p_father_gewog_list:[],
            father_gewog_list:[],
            p_mother_gewog_list:[],
            mother_gewog_list:[],
            p_gardain_gewog_list:[],
            gardain_gewog_list:[],
            std_villageList:[],
            p_father_villageList:[],
            father_villageList:[],
            p_mother_villageList:[],
            mother_villageList:[],
            p_gardain_villageList:[],
            gardain_villageList:[],
            motherTongueList:[],
            classList:[],
            clasList:[],
            org_details:[],
            streamList:[],
            streamListSelected:[],
            studentTypeList:[],
            studentscholarshipList:[],
            studentbenefitList:[],
            sectionList:[],
            occupationList:[],
            s_classList:[],
            attachments:[],
            personal_form: new form({
                type:'edit',
                student_id:'',
                admission_no:'',
                std_class:'',
                snationality:'',
                cid_passport:'',
                first_name:'',
                middle_name:'',
                last_name:'',
                dob:'',
                sex_id:'',
                dzongkhag:'',
                gewog:'',
                village_id:'',
                fulladdress:'',
                mother_tongue:'',
                studentcode:'',
                attachments:'',
            }),
            guardian_form: new form({
                student_id:'',
                merital_status:'',
                primary_contact:'',
                type:'edit',

                father_nationality:'Bhutanese',
                father_cid_passport:'',
                father_first_name:'',
                father_dob:'',
                father_sex_id:'',
                father_dzongkhag:'',
                father_gewog:'',
                father_village_id:'',
                father_fulladdress:'',
                father_present_dzongkhag:'',
                father_present_gewog:'',
                father_present_village_id:'',
                father_work_address:'',
                father_residence_address:'',
                father_occupation:'',
                father_email:'',
                father_cntct_no:'',

                mother_nationality:'Bhutanese',
                mother_cid_passport:'',
                mother_first_name:'',
                mother_dob:'',
                mother_sex_id:'',
                mother_dzongkhag:'',
                mother_gewog:'',
                mother_village_id:'',
                mother_fulladdress:'',
                mother_present_dzongkhag:'',
                mother_present_gewog:'',
                mother_present_village_id:'',
                mother_work_address:'',
                mother_residence_address:'',
                mother_occupation:'',
                mother_email:'',
                mother_cntct_no:'',

                gardain_nationality:'Bhutanese',
                gardain_cid_passport:'',
                gardain_first_name:'',
                gardain_dob:'',
                gardain_sex_id:'',
                gardain_dzongkhag:'',
                gardain_gewog:'',
                gardain_village_id:'',
                gardain_fulladdress:'',
                gardain_present_dzongkhag:'',
                gardain_present_gewog:'',
                gardain_present_village_id:'',
                gardain_work_address:'',
                gardain_residence_address:'',
                gardain_occupation:'',
                gardain_email:'',
                gardain_cntct_no:'',

            }),
        }
    },
    methods: {
        onChangeFileUpload(e){
              this.personal_form.attachments = e.target.files[0];
            
        },
        openfile(file){
            let file_path=file.replaceAll('/', 'SSS');
            let uri = 'admissions/viewFiles/'+file_path;
            window.location=uri;
        },
        getclassList(){
            this.classList = [];
              axios.get('/masters/loadClassAge')
              .then(Response =>{
                let data = Response.data.data;
                this.s_classList = data;
            })
          },
       
        async getDetailsbyCID(cid,type){
            let selectedVal="";
            if(type=="mother"){
                selectedVal=$('input[name="mother_nationality"]:checked').val();
            }
            if(type=="father"){
                selectedVal=$('input[name="father_nationality"]:checked').val();
            }
            if(type=="gardain"){
                selectedVal=$('input[name="gardain_nationality"]:checked').val();
            }
            if(selectedVal.includes('Bhutan')){
                if ($('#'+cid).val().length != 11){
                    Swal.fire({
                        html: "Please enter 11 digit CID",
                        icon: 'error'
                    });
                }
                else{
                    this.getPersonalDetailsbyCID($('#'+cid).val(),type);
                    //the validation part for student is not applicable in edit and removed
                }
            } else if(selectedVal.includes('Foreign')){
                cid=$('#'+cid).val();
                // let check = await this.validateCID(cid);
                // if(check){
                    this.getDOIDetails(cid);
                // } else {
                //     let text = 'Immigration No/ID No has already been registered in the system';
                //     this.showErrorMsg(text);
                // }
            }
        },
        getDOIDetails(cid){
             $('#first_name').prop('readonly',false);
             $('#middle_name').prop('readonly',false);
             $('#last_name').prop('readonly',false);
             $('#dob_name').prop('readonly',false);
              $('#sex_id').prop('disabled',false);
            axios.get('getDOIData/'+ cid)
            .then(res => {
                let data = res.data.data;
                console.log(data);
                if(data.hasdata){
                    let student_detail =data.studentDetail;
                     this.personal_form.first_name = student_detail.FirstName;
                     $('#first_name').prop('readonly',true);
                     this.personal_form.middle_name = student_detail.MiddleName;
                     $('#middle_name').prop('readonly',true);
                     this.personal_form.last_name = student_detail.LastName;
                     $('#last_name').prop('readonly',true);
                    this.personal_form.dob = student_detail.dob;
                    $('#dob').prop('readonly',true);
                    for(let i=0; i<this.sex_idList.length;i++){
                        if(this.sex_idList[i].name.toLowerCase()==student_detail.Gender.toLowerCase()){
                            $('#sex_id').val(this.sex_idList[i].id).trigger('change');
                            this.personal_form.sex_id =  this.sex_idList[i].id;
                            $('#sex_id').prop('disabled',true);
                        }
                    }
                }else{
                    Swal.fire({
                        text: "No details found on this number",
                        icon: 'error',
                        showCancelButton: true,
                        confirmButtonText: 'Yes!',
                    })
                }
            });
        },
        async getPersonalDetailsbyCID(cidNo,type){
            $('#next_btn').show();
            // $('.guardians-tab').prop('disabled',false);
            // $('.guardians-tab').show();
            // $('#father_details').show();
            // $('#mother_details').show();
            if(type=="father"){
                $("input[type='radio'][name='father_nationality']:checked");
            }
            if(type=="mother"){
                $("input[type='radio'][name='mother_nationality']:checked");
            }
            if(type=="gardain"){
                $("input[type='radio'][name='gardain_nationality']:checked");
            }

            await axios.get('getpersonbycid/'+ cidNo)
            .then(response => {
                if (response.data) {
                    let personal_detail = response.data;
                    if(type=="father"){
                        // $('#fetch_father_details').hide();
                        let father_detail = response.data;
                        let full_name=father_detail.firstName;
                        if(father_detail.middleName!="" && father_detail.middleName!=null){
                            full_name+=' '+father_detail.middleName;
                        }
                        if(father_detail.lastName!="" && father_detail.lastName!=null){
                            full_name+=' '+father_detail.lastName;
                        }
                        this.guardian_form.father_first_name = full_name;
                        $('#father_first_name').prop('readonly',true);
                        this.guardian_form.father_cid_passport = father_detail.cid;
                        $('#father_cid_passport').prop('readonly',true);
                        let dob=personal_detail.dob;
                        if(dob.includes('-')){
                            dob=dob.split('-')[2]+'-'+dob.split('-')[1]+'-'+dob.split('-')[0];
                        }
                        if(dob.includes('/')){
                            dob=dob.split('/')[2]+'-'+dob.split('/')[1]+'-'+dob.split('/')[0];
                        }
                        this.guardian_form.father_dob = dob;
                        $('#father_dob').prop('readonly',true);

                        this.guardian_form.father_dzongkhag =father_detail.dzongkhagId;
                        $('#father_dzongkhag').val(father_detail.dzongkhagId).trigger('change');
                        $('#father_dzongkhag').prop('disabled',true);

                        this.getgewoglist(father_detail.dzongkhagId,'p_father');
                        this.guardian_form.father_gewog = father_detail.gewogId;
                        $('#father_gewog').prop('disabled',true);

                        this.getvillagelist(father_detail.gewogId,'p_father',father_detail.villageSerialNo);
                        this.guardian_form.father_village_id = father_detail.villageSerialNo;
                        $('#father_village_id1').val(father_detail.villageSerialNo).trigger('change').prop('disabled',true);
                        $('#father_permanent_address').hide();
                        $('#father_details').show();
                    }
                    if(type=="mother"){
                        // $('#fetch_mother_details').hide();
                        let mother_detail = response.data;
                        let full_name=mother_detail.firstName;
                        if(mother_detail.middleName!="" && mother_detail.middleName!=null){
                            full_name+=' '+mother_detail.middleName;
                        }
                        full_name+=' '+mother_detail.lastName;
                        this.guardian_form.mother_first_name = full_name;
                        $('#mother_first_name').prop('readonly',true);
                        this.guardian_form.mother_cid_passport = mother_detail.cid;
                        $('#mother_cid_passport').prop('readonly',true);
                        let dob=personal_detail.dob;
                        if(dob.includes('-')){
                            dob=dob.split('-')[2]+'-'+dob.split('-')[1]+'-'+dob.split('-')[0];
                        }
                        if(dob.includes('/')){
                            dob=dob.split('/')[2]+'-'+dob.split('/')[1]+'-'+dob.split('/')[0];
                        }
                        this.guardian_form.mother_dob = dob;
                        $('#mother_dob').prop('readonly',true);

                        this.guardian_form.mother_dzongkhag =mother_detail.dzongkhagId;
                        $('#mother_dzongkhag').val(mother_detail.dzongkhagId).trigger('change');
                        $('#mother_dzongkhag').prop('disabled',true);

                        this.getgewoglist(mother_detail.dzongkhagId,'p_mother');
                        this.guardian_form.mother_gewog = mother_detail.gewogId;
                        $('#mother_gewog').prop('disabled',true);

                        this.getvillagelist(mother_detail.gewogId,'p_mother',mother_detail.villageSerialNo);
                        this.guardian_form.mother_village_id = mother_detail.villageSerialNo;
                        $('#mother_village_id').val(mother_detail.villageSerialNo).trigger('change').prop('disabled',true);
                        // $('#mothers_permanent_address').hide();
                        this.guardian_form.primary_contact='Mother';
                    }
                    if(type=="gardain"){
                        let full_anme=personal_detail.firstName;
                        if(personal_detail.middleName!="" && personal_detail.middleName!=null){
                            full_anme+=' '+personal_detail.middleName;
                        }
                        full_anme+=' '+personal_detail.lastName;
                        this.guardian_form.gardain_first_name = full_anme;
                        $('#gardain_first_name').prop('readonly',true);
                        this.guardian_form.gardain_dzongkhag =personal_detail.dzongkhagId;
                        $('#gardain_dzongkhag').val(personal_detail.dzongkhagId).trigger('change');
                        $('#gardain_dzongkhag').prop('disabled',true);
                        this.getgewoglist(personal_detail.dzongkhagId,'p_gardain');
                        this.guardian_form.gardain_gewog = personal_detail.gewogId;
                        $('#gardain_gewog').val(personal_detail.gewogId).trigger('change').prop('disabled',true);

                        this.getvillagelist(personal_detail.gewogId,'p_gardain');
                        this.guardian_form.gardain_village_id = personal_detail.villageSerialNo;
                        $('#gardain_village_id').val(personal_detail.villageSerialNo).trigger('change').prop('disabled',true);
                        $('#gardain_permanent_address').hide();
                        this.guardian_form.primary_contact='Guardian';
                    }
                }else{
                    this.ciderror = 'Invalid CID.';
                    Swal.fire({
                        html: "No data found for matching CID",
                        icon: 'info'
                    });
                }

            })
            .catch((exception) => {
                console.log('error getPersonalDetailsbyCID:'+exception);
            });
        },


        loadAllActiveMasters(type){
            axios.get('masters/loadGlobalMasters/'+type)
            .then(response =>{
                let data = response;
                if(type=="active_mother_tongue"){
                    this.motherTongueList = data.data.data;
                }
                if(type=="all_active_dzongkhag"){
                    this.dzongkhagList = data.data.data;
                }
                if(type=="all_active_gender"){
                    this.sex_idList = data.data.data;
                }
            })
            .catch(function (error){
                console.log("Error:"+error)
            });
        },

        getgewoglist(id,type,gewog_id){
            let dzoId=$('#dzongkhag').val();
            if(id!=""){
                dzoId=id;
            }
            let uri = 'masters/all_active_dropdowns/dzongkhag/'+dzoId;
            if(type=="std"){
                this.std_gewog_list =[];
            }
            if(type=="p_father"){
                this.p_father_gewog_list=[];
            }
            if(type=="father"){
                this.father_gewog_list=[];
            }
            if(type=="p_mother"){
                this.p_mother_gewog_list=[];
            }
            if(type=="mother"){
                this.mother_gewog_list=[];
            }
            if(type=="p_gardain"){
                this.p_gardain_gewog_list=[];
            }
            if(type=="gardain"){
                this.gardain_gewog_list=[];
            }
            let temp_gewog='';
            axios.get(uri)
            .then(response =>{
                let data = response;
                if(type=="std"){
                    this.std_gewog_list = data.data.data;
                }
                if(type=="p_father"){
                    this.p_father_gewog_list=data.data.data;
                    temp_gewog='father_village_id1';
                }
                if(type=="father"){
                    this.father_gewog_list=data.data.data;
                    temp_gewog='father_present_village_id';
                }
                if(type=="p_mother"){
                    this.p_mother_gewog_list=data.data.data;
                    temp_gewog='mother_village_id';
                }
                if(type=="mother"){
                    this.mother_gewog_list=data.data.data;
                     temp_gewog='mother_present_village_id';
                }
                if(type=="p_gardain"){
                    this.p_gardain_gewog_list=data.data.data;
                    temp_gewog='gardain_village_id';
                }
                if(type=="gardain"){
                    this.gardain_gewog_list=data.data.data;
                     temp_gewog='gardain_present_village_id';
                }
                if(gewog_id!=undefined && gewog_id!=""){
                    $('#'+temp_gewog).val(village_id).trigger("change");
                }
            })
            .catch(function (error){
                console.log("Error:"+error)
            });
        },
        getvillagelist(id,type,village_id){
            let gewogId=$('#gewog').val();
            if(id!=""){
                gewogId=id;
            }
            let uri = 'masters/all_active_dropdowns/gewog/'+gewogId;
            if(type=="std"){
                this.std_villageList =[];
            }
            if(type=="p_father"){
                this.p_father_villageList=[];
            }
            if(type=="father"){
                this.father_villageList=[];
            }
            if(type=="p_mother"){
                this.p_mother_villageList=[];
            }
            if(type=="mother"){
                this.mother_villageList=[];
            }
            if(type=="p_gardain"){
                this.p_gardain_villageList=[];
            }
            if(type=="gardain"){
                this.gardain_villageList=[];
            }
            let village='';
            axios.get(uri)
            .then(response =>{
                let data = response;
                if(type=="std"){
                    this.std_villageList = data.data.data;
                }
                if(type=="p_father"){
                    this.p_father_villageList=data.data.data;
                    village='father_village_id1';
                }
                if(type=="father"){
                    this.father_villageList=data.data.data;
                    village='father_present_village_id';
                }
                if(type=="p_mother"){
                    this.p_mother_villageList=data.data.data;
                    village='mother_village_id';
                }
                if(type=="mother"){
                    this.mother_villageList=data.data.data;
                    village='mother_present_village_id';
                }
                if(type=="p_gardain"){
                    this.p_gardain_villageList=data.data.data;
                    village='gardain_village_id';
                }
                if(type=="gardain"){
                    this.gardain_villageList=data.data.data;
                    village='gardain_present_village_id';
                }
                if(village_id!=undefined){
                    $('#'+village).val(village_id).trigger("change");
                }

            })
            .catch(function (error){
                console.log("Error:"+error)
            });
        },

        /**
         * to load the class list
         */
        loadClassList(uri="loadCommons/getOrgClassStream"){
            axios.get(uri)
            .then(response => {
                let data = response;
                this.classList =  data.data.data;
            })
            .catch(function (error) {
                console.log("Error......"+error)
            });
        },

        loadOrgDetails(org_id){
            axios.get('loadCommons/loadOrgDetails/fullOrgDetbyid/'+org_id)
            .then(response => {
                this.org_details=response.data.data;
                this.personal_form.admission_no = this.org_details.abbr_name;
                if(this.org_details.category.includes('eccd')){
                    this.org_type='ECCD';
                } else {
                    this.org_type='Others';
                }
                axios.get('masters/loadGlobalMasters/admission')
                    .then(response => {
                        let data = response.data.data;
                        let from_date = new Date(data.from_date);
                        let to_date = new Date(data.to_date);
                        let present_date = new Date();
                        if(this.org_type == 'Others'){
                            if(to_date >= present_date && from_date <= present_date){
                            $('#screenName').html('<b>Application for '+data.screenName);
                            }else{
                                $('#screenPermission').show();
                                $('#mainform').hide();
                                $('#message').html("The Admission Dates are closed. <br> Thank You!");
                            }
                        }

                    })
                    .catch(errors => {
                        console.log(errors)
                    });
            })
            .catch((error) => {
                console.log("Error: "+error);
            });
        },

        loadAdmissionDateValidation(){
            let uri='masters/loadValidationcondition';
            axios.get(uri)
            .then(response => {
                let data = response.data.data;
                this.schoolAdmissionDateValidation  = data.date1;
                this.eccdAdmissionDateValidation  = data.date;
            })
            .catch(function (error) {
                console.log('error: '+error);
            });

        },

        shownexttab(nextclass){
            if(nextclass=="basic-tabs"){
                this.changetab('basic-tabs');
            }
            if(nextclass=="guardians-tab"){
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
                let formData = new FormData();
                formData.append('snationality', this.personal_form.snationality);
                formData.append('cid_passport', this.personal_form.cid_passport);
                formData.append('admission_no', this.personal_form.admission_no);
                formData.append('first_name', this.personal_form.first_name);
                formData.append('middle_name', this.personal_form.middle_name);
                formData.append('last_name', this.personal_form.last_name);
                formData.append('dob', this.personal_form.dob);
                formData.append('sex_id', this.personal_form.sex_id);
                formData.append('dzongkhag', this.personal_form.dzongkhag);
                formData.append('gewog', this.personal_form.gewog);
                formData.append('village_id', this.personal_form.village_id);
                formData.append('std_class', this.personal_form.std_class);
                formData.append('mother_tongue', this.personal_form.mother_tongue);
                formData.append('fulladdress', this.personal_form.fulladdress);
                formData.append('attachments', this.personal_form.attachments);
                // formData.append('attachments', this.filepth);
                formData.append('type','edit');
                formData.append('student_id', this.personal_form.student_id);
                axios.post('/admissions/saveStudentDetailsFromPortal',formData, config)
                .then((response) => {
                    this.guardian_form.student_id=this.personal_form.student_id;
                    Toast.fire({
                        icon: 'success',
                        title: 'Student Personal Details has been updated successfully'

                    });

                    this.changetab(nextclass);
                })
                .catch((error) => {
                    // this.personal_form.errors.errors = error.response.data;
                    console.log("Error:"+error);
                    this.changetab('basic-tabs');
                })
            }
            if(nextclass=="details-tab"){
                this.guardian_form.primary_contact=$("input[type='radio'][name='primary_contact']:checked").val();
                this.guardian_form.post('/admissions/saveStudentGardianDetails')
                .then((response) =>{
                   Toast.fire({
                        icon: 'success',
                        title: 'Guardian Details has been updated successfully'

                    });
                    this.changetab(nextclass);
                })
                .catch((error) => {
                    this.changetab('guardians-tab');
                    this.applyselect('guardian');
                    console.log("Error:"+error);
                });
            }

        },
        submitfinalform(){
            Swal.fire({
                text: 'Are you sure you wish to submit these form ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
                }).then((result) =>{
                if (result.isConfirmed){
                    this.guardian_form.primary_contact=$("input[type='radio'][name='primary_contact']:checked").val();
                    this.guardian_form.post('/admissions/saveStudentGardianDetails')
                    .then((response) =>{
                        Toast.fire({
                            icon: 'success',
                            title: 'Parents and Guardian Details has been updated successfully'

                    });
                    })
                    .catch((error) => {
                        $('#primary_contact_error').html(error.response.data.primary_contact);
                        this.changetab('guardians-tab');
                        this.applyselect('guardian');
                    })
                }
            })
        },
        changetab(nextclass){
            $('#tabhead >li >a').removeClass('active');
            $('#tabhead >li >a >span').addClass('bg-gradient-secondary text-white');
            $('.'+nextclass+' >a').addClass('active');
            $('.'+nextclass+' >a >span').removeClass('bg-gradient-secondary text-white');
            $('.'+nextclass+' >a').removeClass('disabled');
            $('.tab-content-details').hide();
            $('#'+nextclass).show().removeClass('fade');
        },
        applyselect(type){
            if(type=="std"){
                this.applyselect2field('sex_id');
                this.applyselect2field('dzongkhag');
                this.applyselect2field('gewog');
                this.applyselect2field('village_id');
                this.applyselect2field('mother_tongue');
            }
            if(type=="guardian"){
                this.applyselect2field('merital_status');
                this.applyselect2field('father_dzongkhag');
                this.applyselect2field('father_gewog');
                this.applyselect2field('father_village_id1');
                this.applyselect2field('father_present_dzongkhag');
                this.applyselect2field('father_present_gewog');
                this.applyselect2field('father_present_village_id');
                this.applyselect2field('father_occupation');
                this.applyselect2field('mother_dzongkhag');
                this.applyselect2field('mother_gewog');
                this.applyselect2field('mother_village_id');
                this.applyselect2field('mother_present_dzongkhag');
                this.applyselect2field('mother_present_gewog');
                this.applyselect2field('mother_present_village_id');
                this.applyselect2field('mother_occupation');
                this.applyselect2field('gardain_dzongkhag');
                this.applyselect2field('gardain_gewog');
                this.applyselect2field('gardain_village_id');
                this.applyselect2field('gardain_present_dzongkhag');
                this.applyselect2field('gardain_present_gewog');
                this.applyselect2field('gardain_present_village_id');
                this.applyselect2field('gardain_occupation');
            }
            if(type=="class"){
                this.applyselect2field('class');
                this.applyselect2field('stream');
                this.applyselect2field('section');
                this.applyselect2field('student_type');
            }

        },

        changefunction(id){
            if($('#'+id).val()!=""){
                $('#'+id).removeClass('is-invalid select2');
                $('#'+id+'_err').html('');
                $('#'+id).addClass('select2');
            }
            if(id=="sex_id"){
                this.personal_form.sex_id=$('#sex_id').val();
            }
            if(id=="dzongkhag"){
                this.personal_form.dzongkhag=$('#dzongkhag').val();
                this.getgewoglist($('#dzongkhag').val(),'std');
            }
            if(id=="gewog"){
                this.personal_form.gewog=$('#gewog').val();
                this.getvillagelist($('#gewog').val(),'std');
            }
            if(id=="village_id"){
                this.personal_form.village_id=$('#village_id').val();
            }
            if(id=="std_class"){
                this.personal_form.std_class=$('#std_class').val();
            }
            if(id=="mother_tongue"){
                this.personal_form.mother_tongue=$('#mother_tongue').val();
            }

            if(id=="merital_status"){
                this.guardian_form.merital_status=$('#merital_status').val();
            }
            if(id=="father_dzongkhag"){
                this.guardian_form.father_dzongkhag=$('#father_dzongkhag').val();
                this.getgewoglist($('#father_dzongkhag').val(),'p_father');
            }
            if(id=="father_gewog"){
                this.guardian_form.father_gewog=$('#father_gewog').val();
                this.getvillagelist($('#father_gewog').val(),'p_father');
            }
            if(id=="father_village_id1"){
                this.guardian_form.father_village_id=$('#father_village_id1').val();
            }
            if(id=="father_present_dzongkhag"){
                this.guardian_form.father_present_dzongkhag=$('#father_present_dzongkhag').val();
                this.getgewoglist($('#father_present_dzongkhag').val(),'father');
            }
            if(id=="father_present_gewog"){
                this.guardian_form.father_present_gewog=$('#father_present_gewog').val();
                this.getvillagelist($('#father_present_gewog').val(),'father');
            }
            if(id=="father_present_village_id"){
                this.guardian_form.father_present_village_id=$('#father_present_village_id').val();
            }
            if(id=="father_occupation"){
                this.guardian_form.father_occupation=$('#father_occupation').val();
            }

            if(id=="mother_dzongkhag"){
                this.guardian_form.mother_dzongkhag=$('#mother_dzongkhag').val();
                this.getgewoglist($('#mother_dzongkhag').val(),'p_mother');
            }
            if(id=="mother_gewog"){
                this.guardian_form.mother_gewog=$('#mother_gewog').val();
                this.getvillagelist($('#mother_gewog').val(),'p_mother');
            }
            if(id=="mother_village_id"){
                this.guardian_form.mother_village_id=$('#mother_village_id').val();
            }
            if(id=="mother_present_dzongkhag"){
                this.guardian_form.mother_present_dzongkhag=$('#mother_present_dzongkhag').val();
                this.getgewoglist($('#mother_present_dzongkhag').val(),'mother');
            }
            if(id=="mother_present_gewog"){
                this.guardian_form.mother_present_gewog=$('#mother_present_gewog').val();
                this.getvillagelist($('#mother_present_gewog').val(),'mother');
            }
            if(id=="mother_present_village_id"){
                this.guardian_form.mother_present_village_id=$('#mother_present_village_id').val();
            }
            if(id=="mother_occupation"){
                this.guardian_form.mother_occupation=$('#mother_occupation').val();
            }

            if(id=="gardain_dzongkhag"){
                this.guardian_form.gardain_dzongkhag=$('#gardain_dzongkhag').val();
                this.getgewoglist($('#gardain_dzongkhag').val(),'p_gardain');
            }
            if(id=="gardain_gewog"){
                this.guardian_form.gardain_gewog=$('#gardain_gewog').val();
                this.getvillagelist($('#gardain_gewog').val(),'p_gardain');
            }
            if(id=="gardain_village_id"){
                this.guardian_form.gardain_village_id=$('#gardain_village_id').val();
            }
            if(id=="gardain_present_dzongkhag"){
                this.guardian_form.gardain_present_dzongkhag=$('#gardain_present_dzongkhag').val();
                this.getgewoglist($('#gardain_present_dzongkhag').val(),'gardain');
            }
            if(id=="gardain_present_gewog"){
                this.guardian_form.gardain_present_gewog=$('#gardain_present_gewog').val();
                this.getvillagelist($('#gardain_present_gewog').val(),'gardain');
            }
            if(id=="gardain_present_village_id"){
                this.guardian_form.gardain_present_village_id=$('#gardain_present_village_id').val();
            }
            if(id=="gardain_occupation"){
                this.guardian_form.gardain_occupation=$('#gardain_occupation').val();
            }

            if(id=="class"){
                this.class_form.class=$('#class').val();
                $('#stream_section').hide();
                if($('#class option:selected').text()=="XI" || $('#class option:selected').text()=="XII"){
                    $('#stream_section').show();
                    this.showstream($('#class').val());
                }
                else{
                    this.getExistingSection($('#class').val());
                }
            }
            if(id=="stream"){
                this.class_form.stream=$('#stream').val();
                this.getExistingSection($('#stream').val());
            }
            if(id=="section"){
                this.class_form.section=$('#section').val();
            }
            if(id=="student_type"){
                this.class_form.student_type=$('#student_type').val();
            }
        },
        showstream(valu){
            this.streamListSelected=[];
            axios.get('/organization/getStreamByClassId/'+valu)
            .then(response => {
                let data = response.data;
                this.streamListSelected = data;
            });
        },
        getExistingSection(classId){
            this.class_form.class_stream_id=classId;
            this.sectionList=[];
            axios.get('/organization/getExistingSectionByClass/'+classId)
            .then(response => {
                let data = response.data;
                if(data != ""){
                    this.sectionList=data;
                }
            });
        },
        showstdidentity:function(type){
            $('#dzo_gewog_village').hide();
            if(type=="Student-Non-Bhutanese"){
                $('#level_name').html('Immigration/Passport/Other Identification No: *');
                $('#std_permanent_address').show();
                $('#mothertongue').hide();
                $('#first_name').prop('readonly',false);
                $('#middle_name').prop('readonly',false);
                $('#last_name').prop('readonly',false);
                $('#dob').prop('readonly',false);
                $('#dzongkhag').prop('disabled',false);
                $('#gewog').prop('disabled',false);
                $('#village_id').prop('disabled',false);
                $('#sex_id').prop('disabled',false);

            }
            if(type=="Student-Bhutanese"){
                $('#first_name').prop('readonly',true);
                $('#middle_name').prop('readonly',true);
                $('#last_name').prop('readonly',true);
                $('#dob').prop('readonly',true);
                $('#dzongkhag').prop('disabled',true);
                $('#gewog').prop('disabled',true);
                $('#village_id').prop('disabled',true);
                $('#sex_id').prop('disabled',true);
                $('#level_name').html('CID No: *');
                $('#dzo_gewog_village').show();
                $('#std_permanent_address').hide();
                $('#fetch_std_data').show();
                $('#mothertongue').show();
            }
            if(type=="Student-Bhutanese-underprocess"){
                $('#first_name').prop('readonly',false);
                $('#middle_name').prop('readonly',false);
                $('#last_name').prop('readonly',false);
                $('#dob').prop('readonly',false);
                $('#dzongkhag').prop('disabled',false);
                $('#gewog').prop('disabled',false);
                $('#village_id').prop('disabled',false);
                $('#sex_id').prop('disabled',false);
                $('#level_name').html('Identification No: *');
                $('#dzo_gewog_village').show();
                $('#std_permanent_address').hide();
                $('#fetch_std_data').hide();
                $('#mothertongue').show();
            }
        },
        showfathersidentity(type){
            if(type=="bhutanese"){
                $('#father_dzo_gewog_village').show();
                $('#father_permanent_address').hide();
                $('#fetch_father_details').show();
            }
            if(type=="foreign"){
                $('#fetch_father_details').hide();
                $('#father_dzo_gewog_village').hide();
                $('#father_permanent_address').show();
            }
        },
        showmothersidentity(type){
            $('#mothers_dzo_gewog_village').hide();
            if(type=="bhutanese"){
                $('#mothers_dzo_gewog_village').show();
                $('#mothers_permanent_address').hide();
                $('#fetch_mother_details').show();
            }
            if(type=="foreign"){
                $('#fetch_mother_details').hide();
                $('#mothers_permanent_address').show();

            }
        },
        showgardainsidentity(type){
            $('#gardain_dzo_gewog_village').hide();
            if(type=="bhutanese"){
                $('#gardain_dzo_gewog_village').show();
                $('#gardain_permanent_address').hide();
                $('#fetch_guradian_details').show();
            }
            else{
                $('#fetch_guradian_details').hide();
                $('#gardain_permanent_address').show();
            }
        },
        showidentity:function(type){
            $('#gardain_section').hide();
            if(type=="primary-contact-guardian"){
                $('#gardain_section').show();
            }
        },

        async validateCID(cid){
            let returntype=true;
            await axios.get('students/getstudentdetailsbyCid/'+cid)
            .then(response => {
                let data = response.data.data;
                if(data != null){
                    returntype=false;
                }
            });
            return returntype;
        },


        showErrorMsg(text){
            Swal.fire({
                html: text,
                icon: 'error'
            });
            $('#first_name').prop('readonly',true);
            $('#middle_name').prop('readonly',true);
            $('#last_name').prop('readonly',true);
            $('#dob').prop('readonly',true);
            $('#dzongkhag').prop('disabled',true);
            $('#gewog').prop('disabled',true);
            $('#village_id').prop('disabled',true);
        },
        async getstudentPersonalDetails(id){
            // $('#father_details').hide();
            // $('#mother_details').hide();
            // $('#gardain_section').hide();
            await axios.get('admissions/getStudentDetails/'+id)
            .then(response => {
                let data = response.data;
                if(data==undefined){
                    data = response.data;
                }
                if(data!= "" && data!=undefined){
                    this.personal_form.student_id=id;
                    this.personal_form.snationality=data.CmnCountryId;

                    this.personal_form.cid_passport=data.CidNo;
                    this.personal_form.first_name=data.FirstName;
                    if(data.MiddleName!=null && data.MiddleName!=undefined && data.MiddleName!="" && data.MiddleName!="null"){
                        this.personal_form.middle_name=data.MiddleName;
                    }

                    this.personal_form.last_name=data.LastName;
                    this.personal_form.dob=data.DateOfBirth;
                    this.personal_form.sex_id=data.CmnSexId;
                    $('#sex_id').val(data.CmnSexId).trigger('change').prop('disabled',true);
                    this.personal_form.dzongkhag=data.CmnDzoId;
                    $('#dzongkhag').val(data.CmnDzoId).trigger('change').prop('disabled',true);
                    this.getvillagelist(data.CmnGewogId,'std');
                    this.getgewoglist(data.CmnDzoId,'std');
                    this.personal_form.gewog=data.CmnGewogId;
                    this.personal_form.village_id=data.CmnChiwogId;
                    this.personal_form.fulladdress=data.Address;
                    this.filepth=data.PhotoPath;
                    this.personal_form.mother_tongue=data.CmnLanguageId;
                    $('#mother_tongue').val(data.CmnLanguageId).trigger('change');
                    if(data.PhotoPath!="null" && data.PhotoPath!=""){
                        this.filepth=data.PhotoPath;
                        $('#filesec').show();
                    } //Attachment path has changed to school as if student has applied multiple school with different attachments
                    if(data.admission_class!=undefined && data.admission_class.Attachment_Path!=""){
                        this.filepth=data.admission_class.Attachment_Path;
                        $('#doc_level').show();
                        $('#filesec').show();
                    }
                    this.personal_form.std_class=data.class_id;
                     $('#std_class').val(data.class_id).trigger('change');
                    this.attachments=data.PhotoPath;

                    if(data.CmnCountryId=="Bhutanese"){
                        $('#s-bhutanese').prop('readonly',true);
                        $('#s-bhutanese-underprocess').prop('readonly',true);
                        $('#s-foreign').prop('readonly',true);
                        $('#cid_passport').prop('readonly',true);
                        $('#first_name').prop('readonly',true);
                        $('#middle_name').prop('readonly',true);
                        $('#last_name').prop('readonly',true);
                        $('#dob').prop('readonly',true);
                        $('#dzongkhag').prop('disabled',true);
                        $('#gewog').prop('disabled',true);
                        $('#village_id').prop('disabled',true);
                        $('#sex_id').prop('disabled',true);
                        $('#level_name').html('CID No: *');
                        $('#dzo_gewog_village').show();
                        $('#std_permanent_address').hide();
                        $('#fetch_std_data').show();
                        $('#mothertongue').show();
                    }
                    else if(data.CmnCountryId=="Foreign"){
                        $('#level_name').html('Immigration/Passport/Other Identification No: *');
                        $('#std_permanent_address').show();
                        $('#mothertongue').hide();
                        $('#cid_passport').prop('readonly',true);
                        $('#first_name').prop('readonly',true);
                        $('#middle_name').prop('readonly',true);
                        $('#last_name').prop('readonly',true);
                        $('#dob').prop('readonly',true);
                        $('#dzongkhag').prop('disabled',true);
                        $('#gewog').prop('disabled',true);
                        $('#village_id').prop('disabled',true);
                        $('#sex_id').prop('disabled',true);
                        $('#mothertongue').hide();
                        $('#dzo_gewog_village').hide();
                    }
                    else{
                       $('#first_name').prop('readonly',false);
                        $('#middle_name').prop('readonly',false);
                        $('#last_name').prop('readonly',false);
                        $('#dob').prop('readonly',false);
                        $('#dzongkhag').prop('disabled',false);
                        $('#gewog').prop('disabled',false);
                        $('#village_id').prop('disabled',false);
                        $('#sex_id').prop('disabled',false);
                        $('#level_name').html('Identification No: *');
                        $('#dzo_gewog_village').show();
                        $('#std_permanent_address').hide();
                        $('#fetch_std_data').hide();
                        $('#mothertongue').show();
                    }
                    
                    this.guardian_form.merital_status=data.CmnParentsMaritalStatusId;
                    $('#merital_status').val(data.CmnParentsMaritalStatusId).trigger('change');
                    this.guardian_form.student_id=id;
                    if(data.parents!=undefined && data.parents.length>0 ){
                        this.guardian_form.primary_contact=data.PrimaryContact;
                        $('input[name=primary_contact]').attr("disabled",true);
                        data.parents.forEach(parent => {
                            if(parent.Relationship=="Father"){
                                $('#father_details').show();
                                this.guardian_form.father_nationality=parent.CmnNationalityId;
                                $('input[name=father_nationality]').attr("disabled",true);

                                this.guardian_form.father_cid_passport=parent.CidNo;
                                this.guardian_form.father_first_name=parent.Name.replaceAll('null','');

                                this.guardian_form.father_dzongkhag=parent.CmnPermanentDzoId;
                                $('#father_dzongkhag').val(parent.CmnPermanentDzoId).trigger('change').prop('disabled',true);

                                this.getgewoglist(parent.CmnPermanentDzoId,'p_father',parent.CmnPermanentGewogId);
                                this.guardian_form.father_gewog=parent.CmnPermanentGewogId;
                                $('#father_gewog').val(parent.CmnPermanentGewogId).trigger('change').prop('disabled',true);

                                this.guardian_form.father_village_id=parent.CmnPermanentChiwogId;
                                this.getvillagelist(parent.CmnPermanentGewogId,'p_father',parent.CmnPermanentChiwogId);
                                $('#father_village_id1').val(parent.CmnPermanentChiwogId).trigger('change').prop('disabled',true);

                                this.guardian_form.father_fulladdress=parent.PermanentAddress;

                                this.guardian_form.father_present_dzongkhag=parent.CmnPresentDzoId;
                                $('#father_present_dzongkhag').val(parent.CmnPresentDzoId).trigger('change');
                                this.getgewoglist(parent.CmnPresentDzoId,'father',parent.CmnPresentGewogId);

                                this.guardian_form.father_present_gewog=parent.CmnPresentGewogId;
                                this.getvillagelist(parent.CmnPresentGewogId,'father',parent.CmnPresentGewogId);
                                $('#father_present_gewog').val(parent.CmnPresentGewogId).trigger('change');

                                this.guardian_form.father_present_village_id=parent.CmnPresentChiwogId;
                                $('#father_present_village_id').val(parent.CmnPresentChiwogId).trigger('change');
                                this.guardian_form.father_work_address=parent.WorkAddress;
                                this.guardian_form.father_residence_address=parent.ResidenceAddress;
                                this.guardian_form.father_occupation=parent.CmnOccupationId;
                                $('#father_occupation').val(parent.CmnOccupationId).trigger('change');
                                this.guardian_form.father_email=parent.Email;
                                this.guardian_form.father_cntct_no=parent.ContactNo;
                                if(parent.CmnNationalityId=="Foreign"){
                                    $('#fetch_father_details').hide();
                                    $('#father_dzo_gewog_village').hide();
                                    $('#father_permanent_address').show();
                                }else{
                                    $('#father_cid_passport').prop('readonly',true);
                                    $('#father_first_name').prop('readonly',true);
                                    $('#father_dzo_gewog_village').show();
                                    $('#father_permanent_address').hide();
                                    $('#father_geowog').val(parent.CmnPermanentGewogId).trigger('change');
                                    $('#father_village_id').val(parent.CmnPermanentChiwogId).trigger('change');
                                }
                            }
                            if(parent.Relationship=="Mother"){
                                $('#mother_details').show();
                                this.guardian_form.mother_nationality=parent.CmnNationalityId;
                                $('input[name=mother_nationality]').attr("disabled",true);
                                this.guardian_form.mother_cid_passport=parent.CidNo;
                                this.guardian_form.mother_first_name=parent.Name.replaceAll('null','');
                                this.guardian_form.mother_dzongkhag=parent.CmnPermanentDzoId;
                                $('#mother_dzongkhag').val(parent.CmnPermanentDzoId).trigger('change').prop('disabled',true);
                                this.guardian_form.mother_gewog=parent.CmnPermanentGewogId;
                                this.getgewoglist(parent.CmnPermanentDzoId,'p_mother',parent.CmnPermanentGewogId);
                                $('#mother_gewog').val(parent.CmnPermanentGewogId).trigger('change').prop('disabled',true);

                                this.guardian_form.mother_village_id=parent.CmnPermanentChiwogId;
                                this.getvillagelist(parent.CmnPermanentGewogId,'p_mother',parent.CmnPermanentChiwogId);
                                $('#mother_village_id').val(parent.CmnPermanentChiwogId).trigger('change').prop('disabled',true);

                                this.guardian_form.mother_fulladdress=parent.PermanentAddress;
                                this.guardian_form.mother_present_dzongkhag=parent.CmnPresentDzoId;
                                $('#mother_present_dzongkhag').val(parent.CmnPresentDzoId).trigger('change');
                                this.getgewoglist(parent.CmnPresentDzoId,'mother'),parent.CmnPresentGewogId;
                                this.getvillagelist(parent.CmnPresentGewogId,'mother',parent.CmnPresentChiwogId);
                                this.guardian_form.mother_present_gewog=parent.CmnPresentGewogId;
                                this.guardian_form.mother_present_village_id=parent.CmnPresentChiwogId;
                                this.guardian_form.mother_work_address=parent.WorkAddress;
                                this.guardian_form.mother_residence_address=parent.ResidenceAddress;
                                this.guardian_form.mother_occupation=parent.CmnOccupationId;
                                $('#mother_occupation').val(parent.CmnOccupationId).trigger('change');
                                this.guardian_form.mother_email=parent.Email;
                                this.guardian_form.mother_cntct_no=parent.ContactNo;
                                if(parent.CmnNationalityId=="Foreign"){
                                    $('#fetch_mother_details').hide();
                                    $('#mothers_dzo_gewog_village').hide();
                                    $('#mothers_permanent_address').show();
                                }else{
                                    $('#mother_cid_passport').prop('readonly',true);
                                    $('#mother_first_name').prop('readonly',true);
                                    $('#mothers_permanent_address').hide();
                                    $('#mothers_dzo_gewog_village').show();
                                    $('#mother_geowog').val(parent.CmnPermanentGewogId).trigger('change');
                                    $('#mother_village_id').val(parent.CmnPermanentChiwogId).trigger('change');
                                }
                            }
                            if(parent.Relationship=="guardian"){
                                $('#gardain_section').show();
                                this.guardian_form.gardain_nationality=parent.CmnNationalityId;
                                $('input[name=gardain_nationality]').attr("disabled",true);
                                if(parent.CmnNationalityId=="Foreign"){
                                    $('#fetch_guradian_details').hide();
                                }
                                this.guardian_form.gardain_cid_passport=parent.CidNo;
                                this.guardian_form.gardain_first_name=parent.Name.replaceAll('null','');
                                this.guardian_form.gardain_dzongkhag=parent.CmnPermanentDzoId;
                                $('#gardain_dzongkhag').val(parent.CmnPermanentDzoId).trigger('change').prop('disabled',true);

                                this.getgewoglist(parent.CmnPermanentDzoId,'p_gardain',parent.CmnPermanentGewogId);
                                this.guardian_form.gardain_gewog=parent.CmnPermanentGewogId;
                                $('#gardain_gewog').val(parent.CmnPermanentGewogId).trigger('change').prop('disabled',true);

                                this.guardian_form.gardain_village_id=parent.CmnPermanentChiwogId;
                                this.getvillagelist(parent.CmnPermanentGewogId,'p_gardain',parent.CmnPermanentChiwogId);
                                $('#gardain_village_id').val(parent.CmnPermanentChiwogId).trigger('change').prop('disabled',true);

                                this.guardian_form.gardain_fulladdress=parent.PermanentAddress;
                                this.guardian_form.gardain_present_dzongkhag=parent.CmnPresentDzoId;
                                $('#gardain_present_dzongkhag').val(parent.CmnPresentDzoId).trigger('change');
                                this.getgewoglist(parent.CmnPresentDzoId,'gardain',parent.CmnPresentGewogId);
                                this.guardian_form.gardain_present_gewog=parent.CmnPresentGewogId;

                                this.guardian_form.gardain_present_village_id=parent.CmnPresentChiwogId;
                                this.getvillagelist(parent.CmnPresentGewogId,'gardain',parent.CmnPresentChiwogId);
                                $('#gardain_present_village_id').val(parent.CmnPresentChiwogId).trigger('change');

                                this.guardian_form.gardain_work_address=parent.WorkAddress;
                                this.guardian_form.gardain_residence_address=parent.ResidenceAddress;
                                this.guardian_form.gardain_occupation=parent.CmnOccupationId;
                                $('#gardain_occupation').val(parent.CmnOccupationId).trigger('change');
                                this.guardian_form.gardain_email=parent.Email;
                                this.guardian_form.gardain_cntct_no=parent.ContactNo;
                                if(parent.CmnNationalityId=="Foreign"){
                                    $('#fetch_mother_details').hide();
                                    $('#gardain_dzo_gewog_village').hide();
                                    $('#gardain_permanent_address').show();
                                }else{
                                    // $('#gardain_cid_passport').prop('readonly',true);
                                    $('#gardain_first_name').prop('readonly',true);
                                    $('#gardain_permanent_address').hide();
                                    $('#gardain_first_name').prop('disabled',true);
                                    $('#gardain_geowog').val(parent.CmnPermanentGewogId).trigger('change');
                                    $('#gardain_village_id').val(parent.CmnPermanentChiwogId).trigger('change');
                                }
                            }
                        });
                    }
                    else{
                        $('#father_details').show();
                        $('#mother_details').show();
                        $('#gardain_section').show();
                        Toast.fire({
                            icon: 'info',
                            title: 'You have not updated parents and guardians details of the child'

                        });
                    }

                }
            });
        },
        loadstaffMasters(type,model){
                let uri = 'admissions/loadStaffMasters/'+type+'/'+model;
                try{
                    return  axios.get(uri).then(response => { return response.data.data});
                }catch(e){
                    console.log('error loadstaffMasters '+e);
                }
        },
        loadCommonMasters(type,modal){
            let uri = 'admissions/loadCommonMasters/'+type+'/'+modal;
            try{
                return  axios.get(uri).then(response => { return response.data.data});
            }catch(e){
                console.log('error loadstaffMasters '+e);
            }
        },
    },

    async mounted() {
        this.getclassList();
        this.loadAdmissionDateValidation();
        this.loadAllActiveMasters('all_active_gender');
        this.loadAllActiveMasters('all_active_dzongkhag');
        this.loadAllActiveMasters('active_mother_tongue');
        this.occupationList = await this.loadCommonMasters('active','Occupation');
        this.marital_statusList =  await this.loadstaffMasters('active','MaritalStatus');
        $('.select2').select2();
        $('.select2').on('select2:select', function (el){
            Fire.$emit('changefunction',$(this).attr('id'));
        });

        Fire.$on('changefunction',(id)=> {
            this.changefunction(id);
        });
        this.loadClassList();
        axios.get('common/getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.loadOrgDetails(data['Agency_Code']);
        })
        .catch(errors => {
            console.log(errors)
        });
        if(this.$route.params.data!=undefined){
            this.getstudentPersonalDetails(this.$route.params.data.id);
        }
    },

}


</script>

